import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  const { t } = useTranslation();
  const formUrl = "https://readdy.ai/api/form/d8tn42suatl81q3tfn30";

  return (
    <footer className="bg-primary-800 text-background-100">
      <div className="w-full px-4 md:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">

          {/* Brand Column */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-9 h-9 rounded-full bg-accent-500 flex items-center justify-center">
                <i className="ri-file-list-3-line text-primary-800 text-lg"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-background-50">
                USFansSpreadsheet
              </span>
            </div>
            <p className="text-foreground-400 text-sm leading-relaxed">
              {t("footer.description")}
            </p>
          </div>

          {/* Newsletter Column */}
          <div>
            <h4 className="text-background-100 text-xs font-semibold tracking-widest uppercase mb-4">
              {t("footer.newsletter")}
            </h4>
            <form
              action={formUrl}
              method="POST"
              data-readdy-form
              className="relative"
            >
              <input
                type="email"
                name="email"
                placeholder={t("footer.newsletter_placeholder")}
                required
                className="w-full bg-transparent border-b border-foreground-500 pb-2 text-sm text-background-50 placeholder-foreground-500 outline-none focus:border-accent-500 transition-colors"
              />
              <input
                type="text"
                name="company_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                className="honeypot-field"
              />
              <button
                type="submit"
                className="absolute right-0 bottom-2 text-accent-500 hover:text-accent-400 transition-colors cursor-pointer"
                aria-label="Subscribe"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </div>
              </button>
              <p className="text-foreground-500 text-xs mt-2">
                {t("footer.newsletter_hint")}
              </p>
            </form>
          </div>

          {/* Categories Column */}
          <div>
            <h4 className="text-background-100 text-xs font-semibold tracking-widest uppercase mb-4">
              {t("footer.categories_title")}
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-foreground-400 hover:text-accent-400 text-sm transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {t(cat.nameKey)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Social Column */}
          <div>
            <h4 className="text-background-100 text-xs font-semibold tracking-widest uppercase mb-4">
              {t("footer.social")}
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/artykul/przewodnik-usfansspreadsheet" className="text-foreground-400 hover:text-accent-400 text-sm transition-colors cursor-pointer">
                  {t("articles.guide_title")}
                </Link>
              </li>
              <li>
                <a href="#" className="text-foreground-400 hover:text-accent-400 text-sm transition-colors cursor-pointer">
                  Twitter / X
                </a>
              </li>
              <li>
                <a href="#" className="text-foreground-400 hover:text-accent-400 text-sm transition-colors cursor-pointer">
                  LinkedIn
                </a>
              </li>
            </ul>
          </div>

        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-foreground-600/20 py-6">
        <div className="w-full px-4 md:px-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            {t("footer.copyright")}
          </p>
          <div className="flex items-center gap-6">
            <Link to="/" className="text-foreground-500 hover:text-accent-400 text-xs transition-colors cursor-pointer">
              {t("nav.home")}
            </Link>
            <a href="#" className="text-foreground-500 hover:text-accent-400 text-xs transition-colors cursor-pointer">
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}